import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_general/marketing')({
	staticData: {
		crumb: ({ context: { L } }) => L.Marketing.Title()
	}
})
